import { MAX_CONCURRENT_REQUESTS } from './pdfConstants';

// ============================================
// Limitador de peticiones concurrentes
// ============================================
let activeRequests = 0;
const requestQueue = [];

export const throttledFetch = async (url, options = {}) => {
  return new Promise((resolve, reject) => {
    const execute = async () => {
      activeRequests++;
      try {
        const response = await fetch(url, options);
        resolve(response);
      } catch (err) {
        reject(err);
      } finally {
        activeRequests--;
        if (requestQueue.length > 0) {
          const next = requestQueue.shift();
          next();
        }
      }
    };
    
    if (activeRequests < MAX_CONCURRENT_REQUESTS) {
      execute();
    } else {
      requestQueue.push(execute);
    }
  });
};


// ============================================
// Verificacion de integridad de imagenes
// Compara el tamano recibido (blob.size) con el esperado (X-Image-Size header)
// Y verifica que el JPEG esta completo (marcador EOI: 0xFF 0xD9)
// ============================================
export const verifyImageIntegrity = async (blob, expectedSize) => {
  if (!expectedSize || expectedSize <= 0) {
    // Sin header de integridad, solo verificar JPEG EOI
    const jpegOk = await checkJpegEOI(blob);
    if (!jpegOk) {
      console.warn(`[Integrity] JPEG TRUNCADO: sin marcador EOI (${blob.size} bytes)`);
      return { isComplete: false, reason: 'truncated_jpeg', receivedSize: blob.size };
    }
    return { isComplete: true, reason: 'no_header' };
  }
  
  if (blob.size < expectedSize) {
    const receivedPercent = ((blob.size / expectedSize) * 100).toFixed(1);
    console.warn(`[Integrity] TRUNCADA: recibidos ${blob.size} de ${expectedSize} bytes (${receivedPercent}%)`);
    return { isComplete: false, receivedSize: blob.size, expectedSize, receivedPercent };
  }
  
  // Verificar marcador JPEG EOI (los ultimos 2 bytes deben ser 0xFF 0xD9)
  const jpegOk = await checkJpegEOI(blob);
  if (!jpegOk) {
    console.warn(`[Integrity] JPEG TRUNCADO: ${blob.size} bytes pero sin marcador EOI`);
    return { isComplete: false, reason: 'truncated_jpeg', receivedSize: blob.size, expectedSize };
  }
  
  return { isComplete: true, receivedSize: blob.size, expectedSize };
};

// Verifica que un blob JPEG termina con el marcador EOI (End Of Image): 0xFF 0xD9
export const checkJpegEOI = async (blob) => {
  if (blob.size < 4) return false;
  try {
    const lastBytes = blob.slice(blob.size - 2);
    const buffer = await lastBytes.arrayBuffer();
    const view = new Uint8Array(buffer);
    return view[0] === 0xFF && view[1] === 0xD9;
  } catch {
    return false;
  }
};
